import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles({
  container: {
    backgroundColor: palette.common.white
  }
});
export default useStyles;